export default function (routeAuthenticated, routeNotAuthenticated) {
  return (to, from, next) => {
    if (
      localStorage.getItem("userInfo") != null &&
      localStorage.getItem("userInfo").length > 0
    ) {
      next(routeAuthenticated);
    } else {
      // localStorage.removeItem("userInfo");
      next(routeNotAuthenticated);
    }
  };
}
